<template>
  <div class="content-warp">
    <a-row :gutter="24">
      <a-col :span="6">
        <div class="content-panle bg-white" style="height:670px">            
          <SingleTreeWithSearch
            ref="treeArea"
            :selectedData="targetOrg"
            :mixNodeName="false"
            @update:selectedOrg="handleSelectedOrg"
          ></SingleTreeWithSearch>            
        </div>
      </a-col>

      <a-col :span="18">
        <div class="content-panle bg-white">
          <div class="table-operation-area">
            <div class="search-form" style="text-align: left">
              <TableTips 
                :total="pagination.total" 
                :selected="selectedRowKeys.length"
                @clearAllSelected="() => {selectedRowKeys = []; selectedRowItems = []}"
              />
            </div>
            <div class="btn-area-inline" style="text-align: right">
              <a-button 
                type="primary" 
                :disabled="!targetOrg" 
                @click="handleShowModalTable"
              >{{$t('visitorMana.path.addDeviceBtn')}}</a-button>
              <a-button 
                type="danger" 
                :disabled="!selectedRowKeys.length" 
                @click="handleDeleteDevices"
              >{{$t('visitorMana.path.removeDeviceBtn')}}</a-button>
            </div>
          </div>

          <a-table 
            class="table-area"
            style="min-height: 584px"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: handleTableItemSelected }"
            :columns="tableColumns" 
            :dataSource="tableData"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
          >
            <span slot="status" slot-scope="text, record">
              <a-tag v-if="text === '不在线'" color="volcano">{{text}}</a-tag>
              <a-tag v-else color="green">{{text}}</a-tag>
            </span>

            <template slot="operation" slot-scope="text, record">
              <div v-if="record.operation">
                <a 
                  class="operation-botton"
                  :disabled="record.operation.disabled"
                  :style="{color: record.operation.color || '#1890ff'}"
                  @click="record.operation.callback(record)"
                >{{$t(record.operation.type)}}</a>
              </div>
            </template>
          </a-table>
        </div>
      </a-col>
    </a-row>

    <!-- 新增设备模态框 -->
    <a-modal
      :title="$t('visitorMana.path.addModalTitle') + ' - '  + modalDeviceDeptName"
      :visible="modalTableVisible"
      dialogClass="add-device-modal"
      :footer="null"
      @cancel="()=>{modalTableVisible=false}"
      :afterClose="handleModalTableHide"
      
    > 
      <TableTips :total="modalTableData.length" />
      <a-table 
        :columns="tableColumns" 
        :dataSource="modalTableData"
        :pagination="modalTablePagination"
        :loading="modalTableLoading"
        @change="handleModalTableChange"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="text === '不在线'" color="volcano">{{text}}</a-tag>
          <a-tag v-else color="green">{{text}}</a-tag>
        </span>

        <template slot="operation" slot-scope="text, record">
          <div v-if="record.operation">
            <a 
              class="operation-botton"
              :disabled="record.operation.disabled"
              :style="{color: record.operation.color || '#1890ff'}"
              @click="record.operation.callback(record)"
            >{{$t(record.operation.type)}}</a>
          </div>
        </template>
      </a-table>

    </a-modal>
  </div>
</template>

<script>
import SingleTreeWithSearch from '@/components/SingleTreeWithSearch';
import TableTips from '@/components/TableTips';
import { mapState } from 'vuex';
import { parsePromiseAllRes, deleteSelectedRow } from '../../utils/utils';
import { createVisitorAuth, deleteVisitorAuth, getOrgAuthedDevices, getOrgUnauthedDevices } from '@/api/visitorPath';

export default {
  name: 'visitorPath',
  components: {
    SingleTreeWithSearch,
    TableTips
  },
  data() {
    return {
      targetOrg: null, // 组织树中选中的对象

      // listSearchForm: this.$form.createForm(this),
      // searchStatusOptions: [],

      // searchStatus: undefined,
      // searchSNOrName: undefined,

      loading: false, // 列表内容是否在加载中
      tableData: [], // 列表数据源
      tableColumns: this.getTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      selectedRowKeys: [], // 列表多选钩中项的Id数组
      selectedRowItems: [], // 列表多选钩中项的数组

      // 添加设备
      modalTableVisible: false,
      modalDeviceDeptName: '',

      modalTableLoading: false,
      modalTableData: [],
      modalTablePagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  watch: {
    lang: function (lang) {
      this.tableColumns = this.getTableColumns()
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData
    })
  },
  created() {
    this.onlineStateMap = {};
    this.enumsData.onlineState.forEach(item => {
      this.onlineStateMap[item.value] = item.title;
    });
    // this.searchStatusOptions = [].concat([{ title: '全部', value: '', key: 'all' }], this.enumsData.onlineState);
  },
  activated() {
    // if (this.tableData.length) {
    //   this.getDevicesListData();
    // }
  },
  methods: {
    getTableColumns() {
      return [
        {
          title: this.$t('visitorMana.path.listSN'),
          dataIndex: 'SN',
          width: '20%'
        },
        {
          title: this.$t('visitorMana.path.listName'),
          dataIndex: 'name',
          width: '20%'
        },
        {
          title: this.$t('visitorMana.path.listOrg'),
          dataIndex: 'deptName',
          width: '25%'
        },
        {
          title: this.$t('visitorMana.path.listStatus'),
          dataIndex: 'status',
          width: '15%',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('visitorMana.path.listOperation'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    // 选定一个组织
    handleSelectedOrg(data) {
      // console.log('-------handleSelectedOrg--------', data);
      this.targetOrg = data;
      this.modalDeviceDeptName = data.nameList.join(' / ')

      this.pagination.current = 1;
      deleteSelectedRow(undefined, this.selectedRowKeys, this.selectedRowItems)
      this.getDevicesListData();
    },

    // 搜索列表
    handleSearch() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          // console.log('handleSearch', values);
          this.searchStatus = values.searchStatus;
          this.searchSNOrName = values.searchSNOrName;

          this.pagination.current = 1;
          deleteSelectedRow(undefined, this.selectedRowKeys, this.selectedRowItems)
          this.getDevicesListData();
        }
      });
    },

    // 获取设备列表数据
    async getDevicesListData() {
      try {
        this.loading = true;
        const res = await getOrgAuthedDevices({
          deptId: this.targetOrg.id,
          perPage: this.pagination.pageSize,
          page: this.pagination.current
          // keyword: this.searchSNOrName && this.searchSNOrName.trim(),
          // onlineState: this.searchStatus,
          // searchChildren: false // 不查询子组织的设备
        })
        this.loading = false;

        this.tableData = this.createDeviceTableData(res.data.collection);
        this.pagination.total = res.data.size
      } catch (error) {
        this.loading = false;
      }
    },
    createDeviceTableData(data) {
      return data.map(item => {
        return {
          key: item.deviceId,
          id: item.deviceId,

          SN: item.deviceSn,
          name: item.deviceName,
          deptName: item.deptFullName,
          status: this.onlineStateMap[item.deviceOnlineState], 
          deptid: item.deptId,                      
          
          operation: {
            type: 'visitorMana.path.listRemoveBtn',
            disabled: false,
            color: '#ff4d4f',
            callback: this.handleDeleteDevice
          }
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      // console.log('-------handleTableChange------', pagination);
      this.pagination.current = pagination.current
      this.getDevicesListData()
    },
    // table项勾选
    handleTableItemSelected(rowKeys, rowItems) {
      this.selectedRowKeys = rowKeys;
      this.selectedRowItems = rowItems;
    },    
    // 打开添加设备模态框
    handleShowModalTable() {
      this.modalTableVisible = true      
      this.getUnauthDevicesListData()      
    },
    // 获取机构未授权（可添加）的设备列表
    async getUnauthDevicesListData() {
      try {
        this.modalTableLoading = true;
        const res = await getOrgUnauthedDevices({
          deptId: this.targetOrg.id,
          perPage: this.modalTablePagination.pageSize,
          page: this.modalTablePagination.current
        })
        this.modalTableLoading = false;

        this.modalTableData = this.createModalTableData(res.data.collection);
        this.modalTablePagination.total = res.data.size;
      } catch (error) {
        this.modalTableLoading = false;
      }
    },
    createModalTableData(data) {
      return data.map(item => {
        return {
          key: item.deviceId,
          id: item.deviceId,

          SN: item.deviceSn,
          name: item.deviceName,
          deptName: item.deptFullName,
          status: this.onlineStateMap[item.deviceOnlineState], 
          deptid: item.deptId,                      
          
          operation: {
            type: 'visitorMana.path.listAddBtn',
            disabled: false,
            callback: this.handleAddDevice
          }
        }
      })
    },
    // 模态框设备列表点击分页时触发
    handleModalTableChange(pagination, filters, sorter) {
      this.modalTablePagination.current = pagination.current;
      this.getUnauthDevicesListData();
    },

    // 提交添加设备
    async handleAddDevice(device) {
      try {
        await createVisitorAuth({
          deptId: this.targetOrg.id,
          deviceId: device.id
        })
        this.getUnauthDevicesListData();
        this.pagination.current = 1;
        this.getDevicesListData();
        this.$notification.success({
          message: this.$t('visitorMana.path.addSuccess')
        });
      } catch (error) {}
    },
    // 关闭添加设备模态框
    handleModalTableHide(e) {
      this.modalTableData = []
      this.modalTablePagination = {
        current: 1,
        pageSize: 10,
        total: 0
      }
    },
    
    // 移除设备
    handleDeleteDevice(device) {
      this.$confirm({
        title: this.$t('visitorMana.path.removeWarning'),
        content: this.$t('visitorMana.path.removeWarningDesc'),
        okText: this.$t('visitorMana.path.confirmBtn'),
        cancelText: this.$t('visitorMana.path.cancelBtn'),
        onOk: () => { this.deleteDeviceRquest([device.id]) },
        onCancel() {}
      });
    },
    // 批量移除设备
    handleDeleteDevices() {
      this.$confirm({
        title: new Function('count', this.$t('visitorMana.path.batchRemoveWarning'))(this.selectedRowKeys.length),
        content: this.$t('visitorMana.path.removeWarningDesc'),
        okText: this.$t('visitorMana.path.confirmBtn'),
        cancelText: this.$t('visitorMana.path.cancelBtn'),
        onOk: () => { this.deleteDeviceRquest(this.selectedRowKeys) },
        onCancel() {}
      });
    },   
    // 移除设备的请求集合
    deleteDeviceRquest(idsArr) {
      const deletePromises = idsArr.map(item => this.getDeleteDeviceAxios(item));
      Promise.all(deletePromises).then(resArr => {
        // 处理 Promise.all 返回结果
        const { successRes } = parsePromiseAllRes(
          this, 
          resArr, 
          {
            successMsg: new Function('count', this.$t('visitorMana.path.batchRemoveSuccess')),
            failMsg: new Function('count', this.$t('visitorMana.path.bacthRemoveFail')),
            targets: this.selectedRowItems.map(item => { return { id: item.id, name: item.name } })
          }
        )
        // 有删除成功的结果，则刷新列表
        if (successRes.length) this.refreshDeviceTableData(successRes.length)
      }).catch(err => {})
    },
    // 删除后刷新列表
    refreshDeviceTableData(successCount) {
      if (this.tableData.length === successCount) {
        --this.pagination.current
      }
      this.getDevicesListData(this.pagination.current || 1);
    },
    // 移除设备的请求
    async getDeleteDeviceAxios(id) {
      try {
        const res = await deleteVisitorAuth({
          deviceId: id,
          deptId: this.targetOrg.id
        })
        deleteSelectedRow(id, this.selectedRowKeys, this.selectedRowItems)
        return Promise.resolve({ res: res, targetId: id })
      } catch (error) {
        return Promise.resolve({ res: error, targetId: id })
      }
    }
  }
}
</script>

<style>
  .add-device-modal{
    width: 750px !important;
  }
  .add-device-modal .ant-modal-content .ant-modal-body{
    padding: 0 10px !important;
  }
</style>
<style scoped>
</style>